import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@eig-builder/core-ui/styles'

// Expansion panel
import ExpansionPanel from '@eig-builder/core-ui/ExpansionPanel'
import ExpansionPanelSummary from '@eig-builder/core-ui/ExpansionPanelSummary'
import ExpansionPanelDetails from '@eig-builder/core-ui/ExpansionPanelDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import Text from 'localize'
import './lang'

const styles = theme => ({
  pickupLabel: {
    fontSize: '0.9rem',
    fontWeight: '600',
    width: '100%'
  },
  expansionPanel: {
    boxShadow: 'none'
  },
  expansionPanelSummary: {
    borderTop: '1px solid #E3E3E3',
    '& div:nth-child(1)': {
      margin: theme.spacing(1.5) + 'px !important'
    }
  },
  expansionPanelDetails: {
    display: 'flex',
    flexDirection: 'column',
    fontWeight: '300',
    padding: theme.spacing(4.5),
    paddingTop: 0
  },
  addressBlock: {
    paddingBottom: theme.spacing(3)
  }
})

const generateCustomStyle = themeColors => {
  if (themeColors) {
    const { backgroundColor, textColor } = themeColors

    if (backgroundColor || textColor) {
      return (
        <style>
          {backgroundColor &&
            `
            .pickup-address-and-instructions div {
              background-color:${backgroundColor}
            }
          `}
          {textColor &&
            `
            .pickup-address-and-instructions div {
              color:${textColor}
            }
          `}
        </style>
      )
    }
  }
}

function PickupAddressAndInstructions (props) {
  const {
    classes,
    pickupAddress,
    pickupInstruction,
    themeColors
  } = props

  const {
    address,
    city,
    state
  } = pickupAddress

  return (
    <div className='row pickup-address-and-instructions'>
      {generateCustomStyle(themeColors)}
      <div className={classes.pickupLabel}>
        <ExpansionPanel className={classes.expansionPanel}>
          <ExpansionPanelSummary className={classes.expansionPanelSummary} expandIcon={<ExpandMoreIcon />}>
            <Text message='modules.pickupInstructions.title' />
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.expansionPanelDetails}>
            <div className={classes.addressBlock}>
              <Text message='modules.pickupInstructions.address' />
              {` ${address}, ${city}, ${state}, ${pickupAddress.postal_code}`}
            </div>
            {!!pickupInstruction && <div><Text message='modules.pickupInstructions.instructions' /> {pickupInstruction}</div>}
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    </div>
  )
}

PickupAddressAndInstructions.propTypes = {
  classes: PropTypes.object,
  pickupInstruction: PropTypes.string,
  pickupAddress: PropTypes.object,
  themeColors: PropTypes.object
}

export default withStyles(styles)(PickupAddressAndInstructions)
